import PrimaryButton from 'core-system/Button/PrimaryButton'
import SecondaryButton from 'core-system/Button/SecondaryButton'
import FlexContainer from 'core-system/FlexContainer'
import { NumberFormatter, NumberInput } from 'core-system/Input/NumberInput'
import Text from 'core-system/Text'
import TextField from 'core-system/TextField'
import React from 'react'
import styled from 'styled-components'

const FormBody = styled(FlexContainer)`
  width: 100%;
  height: 100%;
  flex-direction: column;
`

const FormContainer = styled(FlexContainer)`
  flex-direction: column;
`

const FormField = styled(FlexContainer)`
  flex-direction: row;
  align-items: center;
  width: 70%;
  margin-bottom: 2rem;
  gap: 1rem;
`

const FormHeader = styled(FlexContainer)`
  flex-direction: column;
  justify-content: flex-start;
  margin-bottom: 2rem;
  width: 70%;
`

const InputContainer = styled(FlexContainer)`
  width: 23rem;
`

interface MyCommuterGiveOTRProps {
  otrAmount: number
  onOTRAmountChange: (otrAmount: number) => void
  onOTRMemoChange: (otrMemo: string) => void
  onCancel: () => void
  onGiveOTR: () => void
  isGiveOTRDisabled: boolean
}

const MyCommuterGiveOTR = React.memo((props: MyCommuterGiveOTRProps) => {
  const {
    otrAmount,
    onOTRAmountChange,
    onOTRMemoChange,
    onCancel,
    onGiveOTR,
    isGiveOTRDisabled,
  } = props

  return (
    <>
      <FormContainer>
        <FormHeader>
          <Text variant='h5' marginBottom='0.5rem'>
            Give One Time Reward
          </Text>
          <Text variant='action4'>
            Please enter an amount and description for the One Time Reward
          </Text>
        </FormHeader>
        <FormBody>
          <FormField>
            <Text variant='action1'>Amount:</Text>
            <InputContainer>
              <NumberInput
                padding='1rem'
                onValueChange={onOTRAmountChange}
                value={otrAmount}
                height='3rem'
              >
                <NumberFormatter decimalScale={0} fontVariant='action1' />
              </NumberInput>
            </InputContainer>
          </FormField>
          <FormField>
            <Text variant='action1'>Description:</Text>
            <InputContainer>
              <TextField
                onChange={(e) => onOTRMemoChange(e.target.value)}
                maxLength={256}
                width='22.5rem'
              />
            </InputContainer>
          </FormField>
        </FormBody>
      </FormContainer>
      <FlexContainer justifyContent='flex-end' marginTop='3rem'>
        <SecondaryButton onClick={onCancel} style={{ marginRight: '1rem' }}>
          Cancel
        </SecondaryButton>
        <PrimaryButton onClick={onGiveOTR} disabled={isGiveOTRDisabled}>
          Give One Time Reward
        </PrimaryButton>
      </FlexContainer>
    </>
  )
})

if (process.env.NODE_ENV !== 'production') {
  MyCommuterGiveOTR.displayName = 'MyCommuterGiveOTR'
}

export default MyCommuterGiveOTR
